/* GordijnenXL lead events: publiceert WhatsApp-, telefoon-, e-mail- en formulier-acties als
   Shopify customer events, zodat pixels (Google, Meta, TikTok) ze als conversie kunnen meten.
   De pixels zelf draaien in de Shopify-sandbox en abonneren zich via analytics.subscribe(). */
(function () {
  'use strict';
  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var type = null;
    if (/wa\.me\/|api\.whatsapp\.com|whatsapp:\/\//i.test(href)) type = 'gxl_whatsapp_click';
    else if (/^tel:/i.test(href)) type = 'gxl_phone_click';
    else if (/^mailto:/i.test(href)) type = 'gxl_email_click';
    if (!type) return;
    publish(type, {
      href: href.slice(0, 200),
      page: location.pathname,
      label: (a.textContent || a.getAttribute('aria-label') || '').trim().slice(0, 60)
    });
  }, true);
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.getAttribute) return;
    var action = f.getAttribute('action') || '';
    if (/\/contact/i.test(action)) publish('gxl_contact_form_submit', { page: location.pathname });
  }, true);
})();
